import React from 'react';
import { MapPin, Clock } from 'lucide-react';

const ServiceRequestsList = ({ filteredRequests, getPriorityColor, getStatusColor, getRecommendedTechnicians, setSelectedRequest, setShowAssignModal }) => (
  <div className="bg-white rounded-lg shadow-sm border">
    <div className="px-6 py-4 border-b border-gray-200">
      <h2 className="text-xl font-semibold text-gray-900">Service Requests</h2>
    </div>
    <div className="divide-y divide-gray-200">
      {filteredRequests.map((request) => {
        const recommendedTechs = getRecommendedTechnicians(request);

        return (
          <div key={request.id} className="p-6 hover:bg-gray-50">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-lg font-medium text-gray-900">
                    {request.title}
                  </h3>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(request.priority)}`}>
                    {request.priority}
                  </span>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(request.status)}`}>
                    {request.status}
                  </span>
                </div>

                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                  <div className="flex items-center gap-1">
                    <MapPin className="h-4 w-4" />
                    {request.property}
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="h-4 w-4" />
                    Due: {request.dueDate}
                  </div>
                  <div>
                    Est: {request.estimatedTime}
                  </div>
                </div>

                <p className="text-gray-700 mb-3">{request.description}</p>

                {request.status === 'Assigned' && (
                  <p className="text-sm text-blue-600 mb-3">
                    Assigned to: {request.assignedTo || 'Unknown'}
                    {/* Debug info */}
                    {process.env.NODE_ENV === 'development' && (
                      <span className="text-xs text-gray-500 ml-2">
                        (Debug: status={request.status}, assignedTo="{request.assignedTo}")
                      </span>
                    )}
                  </p>
                )}

                {request.status === 'Unassigned' && recommendedTechs.length > 0 && (
                  <div className="mb-3">
                    <p className="text-sm font-medium text-gray-700 mb-2">Recommended Technicians:</p>
                    <div className="flex gap-2">
                      {recommendedTechs.slice(0, 3).map(tech => (
                        <span key={tech.id} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                          {tech.name} ({tech.rating}★)
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {request.status === 'Unassigned' && (
                  <button
                    onClick={() => {
                      setSelectedRequest(request);
                      setShowAssignModal(true);
                    }}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Assign Technician
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default ServiceRequestsList;
